// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1hHFN","location":"Header_location__3k4UD"};